<div class="caticon" *ngIf="icon && cat">
  <ng-container *ngIf="icon.icon">
    <span><img [src]="'https://images.eram.cat/slir/w45-c1x1/categoria/'+icon.icon"></span>
  </ng-container>
</div>